import panel from './panel/panel';
import panelSection from './panel-section/panelSection';

const componentObj = {
  controller: 'PanelsCtrl',
  transclude: true,
  bindings: {
    align: '@',
    name: '@',
    focused: '@'
  },
  template:
    `<div id="panel-controls" data-testid="panel-controls">
      <i ng-repeat="panel in $ctrl.panels" 
        class="fa {{:: panel.icon}}" 
        ng-class="{'panel-active' : panel.selected}" 
        ng-click="$ctrl.togglePanel(panel)"',
        uib-tooltip="{{:: panel.titleToken | translate}}"
        tooltip-placement="{{:: $ctrl.tooltipDirection}}"
        data-testid="panel-control-{{:: panel.titleToken}}"
        >
      </i>
    </div>
    <div ng-transclude></div>`
};

function PanelsCtrl(
  localStorageService,
  $element,
  $window
) {
  const ctrl = this;

  function getActivePanel() {
    const storageQueryValue = `websked.panel-${ctrl.name}`;
    return localStorageService.get(storageQueryValue);
  }

  function setPanelStorage(value) {
    const storageQueryValue = `panel-${ctrl.name}`;
    localStorageService.set(`websked.${storageQueryValue}`, value);
  }

  ctrl.$onInit = () => {
    ctrl.panels = [];

    if (ctrl.align === 'right') {
      $element.addClass('flex-row-reverse');
      ctrl.tooltipDirection = 'left';
    } else {
      ctrl.tooltipDirection = 'right';
    }
  };

  ctrl.$postLink = () => {
    const panelName = ctrl.focused || getActivePanel();

    const panelCtrl = ctrl.panels.filter(p => p.name === panelName)[0];

    if (panelCtrl) {
      ctrl.togglePanel(panelCtrl);
    } else if (panelName === 'preview') {
      /**
       * Set the localStorage value to 'pitches' when no panel active
       * so that pitches panel will be open when user navigates to detailed story view
       */
      if ($window.innerWidth > 480) {
        setPanelStorage('pitches');
      } else {
        /**
         * Do not want panels to be open by default on mobile
         * because panels take up full screen width
        */
        setPanelStorage(null);
      }
    }
  };

  ctrl.addPanel = (obj) => {
    ctrl.panels.push(obj);
  };

  ctrl.togglePanel = (panelController) => {
    const panelCtrl = panelController;

    ctrl.panels.forEach((panelInstance) => {
      const p = panelInstance;
      if (p.selected && p !== panelCtrl) {
        p.selected = false;
      }
    });

    if (!panelCtrl.selected) {
      panelCtrl.selected = true;
      if ($window.innerWidth > 480) {
        setPanelStorage(panelCtrl.name);
      } else {
        /**
         * Do not want panels to be open by default on mobile
         * because panels take up full screen width
        */
        setPanelStorage(null);
      }
    } else {
      panelCtrl.selected = false;
      /**
       * Set the localStorage value to 'pitches' when no panel active
       * so that pitches panel will be open when user navigates to detailed story view
       */
      if ($window.innerWidth > 480) {
        setPanelStorage('pitches');
      } else {
        /**
         * Do not want panels to be open by default on mobile
         * because panels take up full screen width
        */
        setPanelStorage(null);
      }
    }
  };
}

const controllerArray = [
  'localStorageService',
  '$element',
  '$window',
  PanelsCtrl
];

const toLoad = [
  panel,
  panelSection
];

export default function (ngModule) {
  ngModule.component('panels', componentObj);
  ngModule.controller('PanelsCtrl', controllerArray);
  toLoad.forEach(fn => fn(ngModule));
}
